export type BookingType = "normal" | "urgent";

export function formatTokenLabel(
  token: number | string,
  bookingType?: string
): string {
  const num = String(token);
  if (bookingType === "urgent") {
    return `(U)-${num}`;
  }
  return num;
}

export function getArrivalTime(
  token: number,
  bookingType: BookingType
): string {
  if (bookingType === "urgent") {
    return "2:00 PM";
  }
  return token >= 1 && token <= 20 ? "2:00 PM" : "3:00 PM";
}

export function bookingTypeLabel(bookingType?: string): string {
  return bookingType === "urgent" ? "Urgent" : "Normal";
}

export function availabilityMessage(
  bookingType: BookingType,
  response: {
    isAvailable?: boolean;
    isNotFull?: boolean;
    isFull?: boolean;
    nextToken?: number | null;
  }
): { message: string; available: boolean } {
  if (!response.isAvailable) {
    return {
      available: false,
      message:
        "This date is not available (clinic closed). Note: clinic is closed on Wednesday and Sunday.",
    };
  }
  if (bookingType === "urgent" && response.isFull) {
    const cap = (response as { urgent_limit?: number }).urgent_limit;
    return {
      available: false,
      message: cap
        ? `Urgent booking quota (${cap}) is full for this date. Try another date or ask the patient to WhatsApp 03334263301.`
        : "Urgent booking quota is full for this date. Try another date or ask the patient to WhatsApp 03334263301.",
    };
  }
  if (!response.isNotFull) {
    const cap = (response as { normal_limit?: number }).normal_limit;
    return {
      available: false,
      message: cap
        ? `Normal booking quota (${cap}) is full for this date. Try another date.`
        : "Normal booking slots are full for this date. Try another date.",
    };
  }
  const nextInfo =
    bookingType === "urgent" && response.nextToken
      ? ` Next urgent token: (U)-${response.nextToken}.`
      : "";
  return {
    available: true,
    message: `${bookingTypeLabel(bookingType)} booking is available for this date.${nextInfo}`,
  };
}

export function buildBookingConfirmation(
  token: number,
  date: string,
  bookingType: BookingType
): string {
  const tokenLabel = formatTokenLabel(token, bookingType);
  const arrival = getArrivalTime(token, bookingType);
  const typeLabel = bookingTypeLabel(bookingType);
  return [
    `${typeLabel} appointment booked successfully.`,
    `Date: ${date}`,
    `Token: ${tokenLabel}`,
    `Arrival time: ${arrival}`,
    "Clinic hours: 2:00 PM – 5:00 PM (listed time is arrival, not checkup time).",
  ].join(" ");
}
